import { ComponentType } from '@angular/cdk/portal';
import { Direction } from '@angular/cdk/bidi';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, TemplateRef } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import {
  MatDialog,
  MatDialogConfig,
  MatDialogRef,
} from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(
    public dialog: MatDialog,
    private overlay: Overlay,
    @Inject(DOCUMENT) private document: Document
  ) {}

  open<T, D = any, R = any>(
    componentOrTemplateRef: ComponentType<T> | TemplateRef<T>,
    config?: MatDialogConfig<D>
  ): MatDialogRef<T, R> {
    return this.dialog.open(
      componentOrTemplateRef,
      Object.assign(
        {
          panelClass: 'ib-dialog',
          autoFocus: true,
          width: '600px',
          closeOnNavigation: true,
          direction: this.document.documentElement.getAttribute(
            'dir'
          ) as Direction,
          //scrollStrategy: this.overlay.scrollStrategies.reposition(),
        },
        config
      )
    );
  }

  closeAll(): void {
    this.dialog.closeAll();
  }
}
